import $ from 'jquery';
window.$ = window.jQuery = $;

import '@popperjs/core';
import './bootstrap';
import './swal';
import './flash_message';
import './tooltip';
import './utils';

import Spinner from './spinner';
window.Spinner = Spinner;
